module.exports = __webpack_public_path__ + "img/mairui.9c08ca33.png";